// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNWANTED VARIABLE
// MODFIED DATA : 10-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import RequestReportActionTypes from './request-report.types';
import {
	requestReportDetailsFetch,
	requestReportDetailsAdd,
	requestReportDetailsDelete,
} from './request-report.service';
import {
	fetchRequestReportDetailsSuccess,
	fetchRequestReportDetailsFailure,
	fetchRequestReportDetailsResponseChanged,
	addRequestReportDetailsSuccess,
	addRequestReportDetailsFailure,
	addRequestReportDetailsResponseChanged,
	deleteRequestReportSuccess,
	deleteRequestReportFailure,
	deleteRequestReportChanged,
} from './request-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START FETCH REQUEST REPORT DETAILS  ******************** */
export function* fetchRequestReportDetails({ payload }: any) {
	try {
		const key = 'FetchRequestedReportKey';
		const {
			companyID,
			databaseName,
			fromDate,
			limit,
			instanceStaffID,
			toDate,
			branchID,
			generalCompanyID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			Limit: limit,
			RequestedBy: instanceStaffID,
			ToDate: toDate,
			BranchID: branchID,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(requestReportDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchRequestReportDetailsFailure(responseData.data));
		} else {
			yield put(fetchRequestReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchRequestReportDetailsFailure(error));
	}
}

export function* resetFetchRequestReportDetailsResponse() {
	yield put(fetchRequestReportDetailsResponseChanged());
}

export function* onFetchRequestReportDetails() {
	yield takeLatest(
		RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_START,
		fetchRequestReportDetails,
	);
}

export function* onFetchRequestReportDetailsResponseReset() {
	yield takeLatest(
		RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_RESPONSE_RESET,
		resetFetchRequestReportDetailsResponse,
	);
}
/** *********************  END FETCH REQUEST REPORT DETAILS ******************** */

/** *********************  ADD FETCH REQUEST REPORT DETAILS  ******************** */
export function* addRequestReportDetails({ payload }: any) {
	try {
		const key = 'AddRequestedReportKey';
		const {
			companyID,
			databaseName,
			requestedBy,
			requestReportPage,
			fromDate,
			toDate,
			branchID,
			centerID,
			groupID,
			memberID,
			dateType,
			collectionMode,
			funderID,
			isBusiness,
			filterData,
			reportMode,
			isFinance,
			generalCompanyID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			RequestedBy: requestedBy,
			RequestReportPage: requestReportPage,
			FromDate: fromDate || '',
			ToDate: toDate || '',
			BranchID: branchID || '',
			CenterID: centerID || '',
			GroupID: groupID || '',
			MemberID: memberID,
			DateType: dateType,
			CollectionMode: collectionMode,
			FunderID: funderID,
			IsBusiness: isBusiness,
			SearchLog: filterData,
			ReportMode: reportMode,
			IsFinance: isFinance,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(requestReportDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addRequestReportDetailsFailure(responseData.data));
		} else {
			yield put(addRequestReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addRequestReportDetailsFailure(error));
	}
}

export function* resetAddRequestReportDetailsResponse() {
	yield put(addRequestReportDetailsResponseChanged());
}

export function* onAddRequestReportDetails() {
	yield takeLatest(
		RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_START,
		addRequestReportDetails,
	);
}

export function* onAddRequestReportDetailsResponseReset() {
	yield takeLatest(
		RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_RESPONSE_RESET,
		resetAddRequestReportDetailsResponse,
	);
}
/** *********************  END FETCH REQUEST REPORT DETAILS ******************** */

/** *********************  ADD FETCH REQUEST REPORT DETAILS  ******************** */
export function* deleteRequestReportCallStart({ payload }: any) {
	try {
		const key = 'DeleteRequestedReportKey';
		const { jobHandlerID, databaseName } = payload;
		const jsonData = {
			JobHandlerID: jobHandlerID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(requestReportDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteRequestReportFailure(responseData.data));
		} else {
			yield put(deleteRequestReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteRequestReportFailure(error));
	}
}

export function* deleteRequestReportCallReset() {
	yield put(deleteRequestReportChanged());
}

export function* onDeleteRequestReport() {
	yield takeLatest(
		RequestReportActionTypes.DELETE_REQUEST_REPORT_START,
		deleteRequestReportCallStart,
	);
}

export function* onDeleteRequestReportResponseReset() {
	yield takeLatest(
		RequestReportActionTypes.DELETE_REQUEST_REPORT_RESET,
		deleteRequestReportCallReset,
	);
}
/** *********************  END FETCH REQUEST REPORT DETAILS ******************** */

export function* requestReportSaga() {
	yield all([
		call(onFetchRequestReportDetails),
		call(onFetchRequestReportDetailsResponseReset),
		call(onAddRequestReportDetails),
		call(onAddRequestReportDetailsResponseReset),
		call(onDeleteRequestReport),
		call(onDeleteRequestReportResponseReset),
	]);
}
